import { render, staticRenderFns } from "./CompanyProfile.vue?vue&type=template&id=0c01ab48&scoped=true&"
import script from "./CompanyProfile.vue?vue&type=script&lang=js&"
export * from "./CompanyProfile.vue?vue&type=script&lang=js&"
import style0 from "./CompanyProfile.vue?vue&type=style&index=0&id=0c01ab48&scoped=true&lang=scss&"
import style1 from "./CompanyProfile.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./CompanyProfile.vue?vue&type=style&index=2&id=0c01ab48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c01ab48",
  null
  
)

export default component.exports